import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: `${Colors.White} !important`,
    fontSize: '12px !important',
    fontWeight: `${FontWeight.Light} !important`,
    textAlign: 'center',
  },
  blue: {
    color: `${Colors.Blue} !important`,
  },
}));

export default useStyles;